export const FLIGHT_STATUS_LIST = {
    ready: "Ready",
    unfinished: "Unfinished",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    completed: "Completed",
} as const;
